import {lazy} from 'react';

export const PartnersDashboard = lazy(() =>
  import('./components/Dashboard/Dashboard')
);

export const PartnersList = lazy(() =>
  import('./components/PartnerList/PartnerList')
);
